module.exports = __webpack_public_path__ + "media/app/assets/specializations/paladin/retribution-cff3152e16933b1add0f1dfdf5c081c5.png";